import React, { Fragment, useMemo } from 'react';
import { useEffect, useState } from "react";
import Select from 'react-select';
import "../../../assets/css/master.css"
import { getAllData, postUsersData, verifytoken } from '../../../services/ApiCallingUserServices';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { loaderActions } from "../../../_actions/loader.actions";
import { ClearLocalStorage } from '../../commonClass/Session';

const Userrights = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [userrights, setUserRights] = useState<any>([]);
    const [backUpRightList, setBackUpRightList] = useState<any>([])
    const [userId, setUserId] = useState(0)
    const [toggleRow, setToggleRow] = useState<any>([]);
    const user = useSelector((store: any) => store.userstatus.tba);
    const menuItem = useSelector((store: any) => store.menuitems.menu);
    const [useradd, setUserAdd] = useState(true);
    const [useredit, setUserEdit] = useState(true);
    const [userexport, setUserExport] = useState(true);
    const [department, setDepartment] = useState('');
    const [rolename, setRoleName] = useState('');
    const [usertype, setUserType] = useState(3);


    const [ProductId, setProductId] = useState(0);
    const [ProductList, setProductList] = useState([]);

    const [optionsData, setOptionsData] = useState<any>({});
    const [selectFilterOption, setSelectFilterOption] = useState<any>({})

    const handleExpandAdmin = (e: any) => {
        const doesExist = toggleRow.includes(e);
        if (doesExist === false) {
            setToggleRow((current: any) => [...current, e]);
        }
        else {
            setToggleRow((oldState: any) => oldState?.filter((item: any) => item !== e));

        }
    }

    const getUserRightsOptions = async () => {
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            await getAllData('/auth/v1/bindmouserrightsoptions').then((userdata) => {
                setOptionsData(userdata.data);
            })
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
    }

    const getUserById = async (Id: any) => {
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            setUserRights([]);
            await getAllData('/auth/v1/bindmouserrightslist?usermasterid=' + Id + "&UserType=" + usertype).then((userdata) => {
                setUserRights(userdata.data);
                if (Id === 0) {
                    setBackUpRightList(userdata.data)
                }
                dispatch(loaderActions.end());
            })
            let pagelink = user?.find((x: any) => {
                if (x?.PageLink === window.location.pathname)
                    return x?.MenuId
            });
            let mid = user?.find((x: any) => x?.MenuId === pagelink?.MenuId);
            if (mid?.URightView === false && mid?.URightView !== undefined) {
                navigate('/dashboard');
            }
            user?.filter((x: any) => x?.MenuId === pagelink?.MenuId).map((obj: any) => {
                setUserAdd(obj?.URightAdd);
                setUserEdit(obj?.URightEdit);
                setUserExport(obj?.URightExport);

            });
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
    }

    const handleUserchange = (e: any) => {
        setUserId(e.value);
        setRoleName(e.RoleName);
        setDepartment(e.DepartmentName);
        getUserById(e.value)
        e?.ProductList?.map((obj: any) => {
            obj.label = obj?.travelCategoryName
            obj.value = obj?.travelCategoryId
            return obj;
        })
        setProductId(e?.ProductList?.[0]?.value)
        setProductList(e?.ProductList ? e?.ProductList : []);
        setUserRights([])
    }

    const handleOnChangeSelect = (name: string, value: any) => {
        setSelectFilterOption((prevState: any) => ({
            ...prevState,
            [name]: value,
            ...(name === 'domain' ? { agency: '' } : {})
        }));
        if (name === 'domain' || name === 'agency') {
            setUserId(0);
            setRoleName('');
            setDepartment('');
            setProductId(0)
            setProductList([]);
            setUserRights(backUpRightList);
        }
    };

    const agencyWiseUserList = useMemo(() => {
        switch (selectFilterOption?.domain?.value) {
            case 2:
                return optionsData?.userList?.filter((user: any) => user.TravelAgentId === selectFilterOption?.agency?.value && user.DomainMasterId === 2);
                break;
            case 3:
                return optionsData?.userList?.filter((user: any) => user.CorporateId === selectFilterOption?.agency?.value && user.DomainMasterId === 3);
                break;
            case 1:
                return optionsData?.userList?.filter((user: any) => user.DomainMasterId === 1)
            default:
                return ([])
                break;
        }
    }, [selectFilterOption?.agency?.label || selectFilterOption?.domain?.label])


    const handlesavadata = async () => {
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            const savedata = {
                UserMasterId: userId,
                MoUserRightsList: userrights,
            }
            const UserData = await postUsersData("/auth/v1/insertorupdatemouserrights", savedata);
            if ((!UserData.status && UserData.data === null) || (!UserData.status && !UserData.data)) {
                dispatch({ type: 'ALERTING', message: UserData.message })
            }
            else {
                if (UserData.status && UserData.data > 0) {
                    dispatch({ type: 'ALERTING', message: UserData.message })
                    handleClearClick();
                }
                else {
                    dispatch({ type: 'ALERTING', message: UserData.message })
                    handleClearClick();
                }
            }
            dispatch(loaderActions.end());
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
        dispatch(loaderActions.end());

    }

    const handleChangeCheck = (
        menuList: any[],
        targetMenuId: number,
        newRoleAddValue: boolean,
        type: string,
    ): any => {
        if (userId === 0) {
            // dispatch(alertActions.error('please select Role'));
        }
        else {
            const updateMenuList = (list: any[]): any[] => {
                return list?.map(item => {
                    const newItem = { ...item };

                    // Recursively update children
                    if (newItem.children && newItem.children.length > 0) {
                        newItem.children = updateMenuList(newItem.children);
                    }

                    // If this is the target item, update the permission
                    if (newItem.menu_Id === targetMenuId) {
                        switch (type) {
                            case 'uRightView':
                            case 'uRightAdd':
                            case 'uRightEdit':
                            case 'uRightExport':
                                newItem[type] = newRoleAddValue;
                                // If any permission is false, set uRoleAll = false
                                if (newItem.uRoleAll && !newRoleAddValue) {
                                    newItem.uRoleAll = false;
                                }
                                break;

                            case 'uRoleAll':
                                newItem.uRoleAll = newRoleAddValue;
                                newItem.uRightView = newRoleAddValue;
                                newItem.uRightAdd = newRoleAddValue;
                                newItem.uRightEdit = newRoleAddValue;
                                newItem.uRightExport = newRoleAddValue;
                                break;
                        }
                    }

                    // Update uRoleAll based on individual permissions
                    const { uRightView, uRightAdd, uRightEdit, uRightExport } = newItem;
                    newItem.uRoleAll = uRightView && uRightAdd && uRightEdit && uRightExport;

                    return newItem;
                });
            };
            const updatedTree = updateMenuList(menuList);
            setUserRights(updatedTree); // Your state update
            return updatedTree;
        }
    }

    const handleClearClick = () => {
        setUserId(0);
        setDepartment('');
        setRoleName('');
        setProductId(0);
        setProductList([]);
        setSelectFilterOption((pre: any) => ({ ...pre, domain: 0, agency: 0 }))
        getUserById(0);
    }

    const handleSelectChange = (e: any) => {
        setProductId(e?.value);
    }

    const renderRows = (items: any[], tempcol: any[], level: number = 0) => {
        return items?.map(item => {
            const isExpanded = toggleRow?.includes(item?.menu_Id);
            const hasChildren = item?.children?.length > 0;

            if (item?.menuType === 1) {
                return (
                    <Fragment key={item?.menu_Id}>
                        <tr>
                            <th
                                className='admin_btn'
                                style={{ width: "275px", paddingLeft: `${13 * (level + 1)}px` }}
                                onClick={() => handleExpandAdmin(item?.menu_Id)}
                                scope="row"
                            >
                                <i
                                    className={`fa fa-angle-${isExpanded ? 'down rotet' : 'down'} me-1`}
                                    aria-hidden="true"
                                ></i>
                                {item?.pageTitle}
                            </th>
                            <td colSpan={5}></td>
                        </tr>

                        {isExpanded && hasChildren && renderRows(item?.children, tempcol, level + 1)}
                    </Fragment>
                );
            }

            if (item?.menuType === 0) {
                return (
                    <tr key={item?.menu_Id}>
                        <th style={{ width: "275px", paddingLeft: `${14 * (level + 2)}px` }} scope="row">{item?.pageTitle}</th>
                        <td>
                            <input
                                className="form-check-input"
                                checked={item?.uRoleAll}
                                name="All"
                                onChange={(e) => handleChangeCheck(tempcol, item?.menu_Id, !item?.uRoleAll, 'uRoleAll')}
                                type='checkbox'
                                value="All"
                            />
                        </td>
                        <td>
                            <input
                                className="form-check-input"
                                checked={item?.uRightView}
                                name="View"
                                onChange={(e) => handleChangeCheck(tempcol, item?.menu_Id, !item?.uRightView, 'uRightView')}
                                type='checkbox'
                                value="View"
                            />
                        </td>
                        <td>
                            <input
                                className="form-check-input"
                                checked={item?.uRightAdd}
                                name="Add"
                                onChange={(e) => handleChangeCheck(tempcol, item?.menu_Id, !item?.uRightAdd, 'uRightAdd')}
                                type='checkbox'
                                value="Add"
                            />
                        </td>
                        <td>
                            <input
                                className="form-check-input"
                                checked={item?.uRightEdit}
                                name="Edit"
                                onChange={(e) => handleChangeCheck(tempcol, item?.menu_Id, !item?.uRightEdit, 'uRightEdit')}
                                type='checkbox'
                                value="Edit"
                            />
                        </td>
                        <td>
                            <input
                                className="form-check-input"
                                checked={item?.uRightExport}
                                name="Export"
                                onChange={(e) => handleChangeCheck(tempcol, item?.menu_Id, !item?.uRightExport, 'uRightExport')}
                                type='checkbox'
                                value="Export"
                            />
                        </td>
                    </tr>
                );
            }
            return null;
        });
    }

    useEffect(() => {
        getUserById(0);
        setSelectFilterOption({
            ...selectFilterOption,
            domain: {}, agency: {}
        })
        getUserRightsOptions();
    }, []);
    return (
        <>
            <div className="mx-2 mt-0 mb-3 heading_color">
                <h2 className='fw-bold'>{menuItem?.[0]?.pageTitle}</h2>
            </div>
            <div className="m-2 heading_color">
                <h4>{menuItem?.[1]?.pageTitle} </h4>
            </div>
            <div className="m-2 ">
                <form action="" className='mt-3' >
                    <div className="mb-3 row mx-1">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="row g-2">
                                <div className='col-md-3 mb-lg-1'>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 col-sm-12">
                                            <label htmlFor="inputPassword6" className="col-form-label required">Select Domain</label>
                                        </div>
                                        <div className=" col-lg-8 col-md-12 col-sm-12">
                                            <Select className="dropdown select_dropdown custom_class"
                                                options={optionsData?.domainList}
                                                value={selectFilterOption?.domain}
                                                onChange={(val: any) => handleOnChangeSelect('domain', val)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-3 mb-lg-1'>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 col-sm-12">
                                            <label htmlFor="inputPassword6" className={`col-form-label ${selectFilterOption?.domain?.value === 1 ? '' : 'required'}`}>Select Agency</label>
                                        </div>
                                        <div className=" col-lg-8 col-md-12 col-sm-12">
                                            <Select
                                                className="dropdown select_dropdown custom_class"
                                                options={
                                                    selectFilterOption?.domain?.value === 2
                                                        ? optionsData?.travelAgentList
                                                        : selectFilterOption?.domain?.value === 3
                                                            ? optionsData?.corporetList : []}
                                                value={selectFilterOption?.agency}
                                                onChange={(val: any) => handleOnChangeSelect('agency', val)}
                                                isDisabled={selectFilterOption?.domain?.value === 1 || !selectFilterOption?.domain?.value}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className='col-md-3 mb-lg-1'>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 col-sm-12">
                                            <label htmlFor="inputPassword6" className="col-form-label required">Select User</label>
                                        </div>
                                        <div className=" col-lg-8 col-md-12 col-sm-12">
                                            <Select className="dropdown select_dropdown custom_class"
                                                options={agencyWiseUserList}
                                                value={agencyWiseUserList?.filter(function (userList: any) {
                                                    return userList.value === userId;
                                                })}
                                                onChange={handleUserchange}
                                                isDisabled={selectFilterOption?.domain?.value === 1 ? false : !selectFilterOption?.agency ? true : false}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className='col-md-3 mb-lg-1'>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 col-sm-12">
                                            <label htmlFor="inputPassword6" className="col-form-label">Department</label>
                                        </div>
                                        <div className=" col-lg-8 col-md-12 col-sm-12">
                                            <input type="text" title={department} id="DepartmentName" className="form-control text-truncate"
                                                name="DepartmentName"
                                                value={department}
                                                maxLength={30}
                                                disabled={true}
                                                placeholder="Department"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className='col-md-3 mb-lg-1'>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 col-sm-12">
                                            <label htmlFor="inputPassword6" className="col-form-label">Role</label>
                                        </div>
                                        <div className=" col-lg-8 col-md-12 col-sm-12">
                                            <input type="text" title={rolename} id="Role" className="form-control text-truncate"
                                                name="Role"
                                                value={rolename}
                                                maxLength={30}
                                                disabled={true}
                                                placeholder="Role"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className='col-md-3 mb-lg-1'>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 col-sm-12">
                                            <label htmlFor="inputPassword6" className="col-form-label">Product</label>
                                        </div>
                                        <div className=" col-lg-8 col-md-12 col-sm-12">
                                            <Select
                                                id='Product'
                                                className="dropdown select_dropdown custom_class"
                                                options={ProductList}
                                                value={ProductList?.filter((fil: any) => fil?.value === ProductId)}
                                                isSearchable
                                                placeholder="Product"
                                                onChange={(e) => handleSelectChange(e)} // assign onChange function
                                                isDisabled={!(ProductList?.length > 1)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mb-3 row">
                        <div className='overflow-auto'>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th className='ps-4' scope="col">Title</th>
                                        <th scope="col">All</th>
                                        <th scope="col">View</th>
                                        <th scope="col">Add</th>
                                        <th scope="col">Edit</th>
                                        <th scope="col">Export</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {renderRows(userrights, userrights)}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center">
                        {(useradd === true || useredit === true) ?
                            <button type="button" className="btn btn-primary mx-1" id="btnAdd" disabled={userId > 0 ? false : true} onClick={handlesavadata} >Save</button>
                            :
                            <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handlesavadata} disabled={true} >Save</button>}
                        <button type="button" className="btn btn-primary mx-1" id="btnClear" onClick={handleClearClick}>Clear</button>
                    </div>
                </form >
            </div>
        </>
    )
}

export default Userrights